/* 曹休（字文烈） */
import { gd } from '../../core/kit.ts';
import { defineHero } from '../define.ts';

export default defineHero({
  id: 'caoxiu', name: '曹休', sub: '字文烈', faction: 'wei', role: '戰士', weapon: 'sword',
  look: { head: 'pony', fx: '#a9d4ff', c: { armor: '#2f4478' } },
  skills: [
    ['千里駒', 'charge', '疾馳突進，造成 {80/127/172/218} 傷害。'],
    ['虎豹連斬', 'multi', '三段連斬，每段 {58/98/138/178} 傷害；最後一段擊倒 0.8 秒。'],
    ['移形', 'blink', '指定一名隊友或敵人（武將、小兵、黃巾賊都可以），立刻和他交換位置。施放距離 {500/600/700/800}。', { sig: 'swap', aim: { kind: 'point', range: [500, 600, 700, 800], area: 60 }, cd: [20, 17, 14, 11], mp: 80 }],
    ['奔襲', 'dash', '向前奔襲連刺四段，每段 {90/140/190} 傷害。', { el: null }],
  ],
  methods: {
    // 曹休「移形」：和指定的隊友或敵人（武將優先）交換位置
    swapPlaces(u, a) {
      const p = a.pt;
      const cand = this.units.filter((t) => t !== u && t.alive && !t.structure && t.kind !== 'boss' && t.kind !== 'cart' && t.kind !== 'ward' && !t.thrown && !t.grabbedBy && gd(p[0], p[1], t.x, t.y) < 90 + t.r && (t.team === u.team || this.hostile(u, t)))
        .sort((x, y) => +(y.kind === 'hero') - +(x.kind === 'hero') || gd(p[0], p[1], x.x, x.y) - gd(p[0], p[1], y.x, y.y));
      const t = cand[0];
      if (!t) { this.tell(u, '那裡沒有可以交換的單位', 'warn'); u.cd[u.spec.skills.indexOf(a.sk)] = 1; return; } // 撲空只給 1 秒冷卻
      this.fx({ k: 'puff', x: u.x, y: u.y }); this.fx({ k: 'puff', x: t.x, y: t.y });
      [u.x, u.y, t.x, t.y] = [t.x, t.y, u.x, u.y];
      t.act = t.kind === 'hero' ? null : t.act; if (t.input) { t.input.moveTo = null; }
      u.f = Math.sign(t.x - u.x) || u.f;
      if (u.human || t.human) this.dmgEvents.push({ x: u.x, y: u.y - 40, text: '移形', team: u.team, src: u.id, tgt: t.id });
    },
  },
  // 專屬招式（技能資料裡的 sig，取代該原型的一般動作）：(u, a, k, dt, cross)，this 是 World
  sigSkills: {
    // 移形
    swap(u, a, k, dt, cross) { if (cross(0.3)) this.swapPlaces(u, a); },
  },
});
